define(
	'DC.Item.Group.Component.View'
,   [
		'Backbone',
        'ProductViews.Price.View',
        'dc_item_group_component.tpl',
        'Product.Model',
        'AjaxRequestsKiller',
        'underscore'
	]
,   function (
        Backbone,
        ProductViewsPriceView,
        dc_item_group_component_tpl,
        ProductModel,
        AjaxRequestsKiller,
        _
	)
{
	'use strict';

    return Backbone.View.extend({
        template: dc_item_group_component_tpl,

        initialize: function(options){
            this.container = options.container;
            this.product = new ProductModel({item: this.model.attributes});
        },

        events: {
            'click [data-action=addComponentToCart]': 'addComponentToCart'
        },

        addComponentToCart: function(e){
            var itemId = this.$(e.target).data('itemId');
            var qty = this.$('#'+itemId+"-quantity").val();

            if(itemId && qty && qty > 0){
                var cart = this.container.getComponent("Cart");
                cart.addLine({line: {
                    quantity: parseInt(qty),
                    item: {
                        internalid: itemId
                    }
                }}).then(function() {
                    cart.triggerAddToCartConfirmation().then(function() {
                        console.log('Line successfully added to cart.');
                    })
                });
            }
        },

        childViews: {
            'Product.Price': function() {
                var product = new ProductModel({item: this.model.attributes});
                return new ProductViewsPriceView({
                    model: product,
                    origin: 'PDPFULL'
                });
            },
        },

        getContext: function(){
            if(!this.model.get('displayname')){
                this.model.set('displayname', this.model.get('storedisplayname2'));
            }
            return {
                item: this.model,
                thumbnail: this.product.getThumbnail()
            }
        }
    })
	
});
